import { withType } from "../../../utils/actionOperations";
import { RENDER_PDF_SET_VALUE_AT_PATH } from "../../constants";

export const setValueAtPath = (path, value) => {
  return (dispatch) => {
    dispatch(withType(RENDER_PDF_SET_VALUE_AT_PATH, { path: path, value: value }));
  };
};
